import React from "react";
import {TextManipulationConfiguration} from "./configuration/text-manipulation-configuration";
import {PreviewTab} from "../preview-tab/preview-tab";

export const TextManipulationStepPanelTabs = {
    configuration: TextManipulationConfiguration,
    preview: PreviewTab,
};
